import { Navigate, useParams } from 'react-router-dom';
import { ROUTES } from '@/config';

export const OsceStatsDetailRedirect = () => {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={ROUTES.OSCE.SESSION_DETAIL.replace(':id', id ?? '')} replace />;
};
